import { render, staticRenderFns } from "./AssetModelFormWrapperComponent.vue?vue&type=template&id=32f18fdc&"
import script from "./AssetModelFormWrapperComponent.vue?vue&type=script&lang=js&"
export * from "./AssetModelFormWrapperComponent.vue?vue&type=script&lang=js&"
import style0 from "./AssetModelFormWrapperComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VExpandTransition,VRadio,VRadioGroup,VRow,VSelect,VSwitch})
